import React from "react";
import { Select, Skeleton } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setLtrVsLtv } from "../../../redux/store/genericReportingSlice";
import FilterDropdown from "./FilterDropdown";

export default function LtrTabDropdowns() {
  const dispatch = useDispatch();
  const ltrVsLtv = useSelector((state) => state.genericReporting.ltr_vs_ltv);

  return (
    <div style={{
      display: "flex",
      flexDirection: "row",
      gap: "0.5vw"
    }}>
      <div>
        <h4>LTR/LTV</h4>
        <Select
          style={{
            width: "10vw",
          }}
          options={[
            { label: "LTR", value: "ltr" },
            { label: "LTV", value: "ltv" },
          ]}
          onChange={(value) => {
            dispatch(setLtrVsLtv(value));
          }}
          value={ltrVsLtv}
        />
      </div>
      <FilterDropdown />
    </div>
  );
}
